module.exports = __webpack_public_path__ + "img/background.2626aae3.svg";